import { buildLegend, buildTooltip, mergeGaugeSettings } from "./shared";
function resolveGaugeValueRange(data, settings) {
    var min = settings.min !== undefined ? settings.min : Number.POSITIVE_INFINITY;
    var max = settings.max !== undefined ? settings.max : Number.NEGATIVE_INFINITY;
    if (settings.min === undefined || settings.max === undefined) {
        data.series.forEach(function (series) {
            if (settings.min === undefined && series.value < min) {
                min = series.value;
            }
            if (settings.max === undefined && series.value > max) {
                max = series.value;
            }
        });
    }
    if (settings.min === undefined && min === Number.POSITIVE_INFINITY) {
        min = 0;
    }
    if (settings.max === undefined && max === Number.NEGATIVE_INFINITY) {
        max = 100;
    }
    if (min === max) {
        max = min + 1;
    }
    return { min: min, max: max };
}
var gaugeChartAdapter = {
    type: "gauge",
    buildOption: function (ctx) {
        var _a, _b, _c, _d;
        var data = ctx.data;
        var settings = mergeGaugeSettings(ctx.settings);
        var legend = buildLegend(data.legend, settings.legend);
        var tooltip = buildTooltip(data.tooltip, {
            trigger: (_b = (_a = settings.tooltip) === null || _a === void 0 ? void 0 : _a.trigger) !== null && _b !== void 0 ? _b : "item",
            enable: (_c = settings.tooltip) === null || _c === void 0 ? void 0 : _c.enable,
            formatter: (_d = settings.tooltip) === null || _d === void 0 ? void 0 : _d.formatter,
        });
        var _e = resolveGaugeValueRange(data, settings), min = _e.min, max = _e.max;
        var series = data.series.map(function (seriesItem) {
            var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o, _p, _q, _r, _s, _t, _u, _v, _w;
            var style = (_a = settings.style) !== null && _a !== void 0 ? _a : "basic";
            var color = (_b = seriesItem.color) !== null && _b !== void 0 ? _b : "#5470C6";
            var styleDefaults = {
                basic: {
                    startAngle: 225,
                    endAngle: -45,
                    splitNumber: 10,
                    progress: false,
                    pointer: {
                        length: "70%",
                        width: 4,
                    },
                    axisLine: {
                        width: 6,
                        color: [
                            [1, color],
                        ],
                    },
                    detail: { fontSize: 18, offsetCenter: [0, "70%"] },
                },
                simple: {
                    startAngle: 225,
                    endAngle: -45,
                    splitNumber: 12,
                    progress: { width: 12 },
                    pointer: {
                        length: "75%",
                        width: 5,
                    },
                    axisLine: {
                        width: 12,
                        color: [
                            [1, color],
                        ],
                    },
                    detail: { fontSize: 28, offsetCenter: [0, "70%"] },
                },
                speed: {
                    startAngle: 210,
                    endAngle: -30,
                    splitNumber: 8,
                    progress: { width: 18 },
                    pointer: {
                        length: "85%",
                        width: 6,
                    },
                    axisLine: {
                        width: 18,
                        color: [
                            [0.75, color],
                            [1, "#E0E0E0"],
                        ],
                    },
                    detail: { fontSize: 36, offsetCenter: [0, "60%"] },
                },
                stageSpeed: {
                    startAngle: 210,
                    endAngle: -30,
                    splitNumber: 6,
                    progress: false,
                    pointer: {
                        length: "78%",
                        width: 6,
                    },
                    axisLine: {
                        width: 18,
                        color: [
                            [0.3, "#57D1F7"],
                            [0.7, "#7CFFB2"],
                            [1, "#FF6E76"],
                        ],
                    },
                    detail: { fontSize: 24, offsetCenter: [0, "65%"] },
                },
            };
            var defaults = (_c = styleDefaults[style]) !== null && _c !== void 0 ? _c : styleDefaults.basic;
            var startAngle = (_e = (_d = settings.startAngle) !== null && _d !== void 0 ? _d : defaults.startAngle) !== null && _e !== void 0 ? _e : 225;
            var endAngle = (_g = (_f = settings.endAngle) !== null && _f !== void 0 ? _f : defaults.endAngle) !== null && _g !== void 0 ? _g : -45;
            var splitNumber = (_j = (_h = settings.splitNumber) !== null && _h !== void 0 ? _h : defaults.splitNumber) !== null && _j !== void 0 ? _j : 10;
            var progressEnabled = settings.showProgress !== undefined
                ? settings.showProgress
                : defaults.progress !== false;
            var pointerEnabled = settings.showPointer !== undefined
                ? settings.showPointer
                : defaults.pointer !== false;
            var axisLineColor = (_l = (_k = defaults.axisLine) === null || _k === void 0 ? void 0 : _k.color) !== null && _l !== void 0 ? _l : [
                [1, color],
            ];
            var axisLineWidth = (_o = (_m = defaults.axisLine) === null || _m === void 0 ? void 0 : _m.width) !== null && _o !== void 0 ? _o : 10;
            return {
                type: "gauge",
                name: seriesItem.name,
                min: (_p = settings.min) !== null && _p !== void 0 ? _p : min,
                max: (_q = settings.max) !== null && _q !== void 0 ? _q : max,
                startAngle: startAngle,
                endAngle: endAngle,
                splitNumber: splitNumber,
                axisLine: {
                    lineStyle: {
                        width: axisLineWidth,
                        color: axisLineColor,
                    },
                },
                progress: progressEnabled
                    ? {
                        show: true,
                        width: (_r = (defaults.progress && defaults.progress.width)) !== null && _r !== void 0 ? _r : axisLineWidth,
                        itemStyle: {
                            color: color,
                        },
                    }
                    : undefined,
                pointer: pointerEnabled
                    ? defaults.pointer
                        ? {
                            show: true,
                            length: (_s = defaults.pointer.length) !== null && _s !== void 0 ? _s : "70%",
                            width: defaults.pointer.width,
                            itemStyle: defaults.pointer.color
                                ? { color: defaults.pointer.color }
                                : undefined,
                        }
                        : undefined
                    : { show: false },
                axisLabel: {
                    formatter: "{value}",
                },
                detail: {
                    valueAnimation: true,
                    formatter: (_t = seriesItem.detailFormatter) !== null && _t !== void 0 ? _t : (function (value) { return value.toFixed(0); }),
                    color: color,
                    fontSize: (_u = defaults.detail) === null || _u === void 0 ? void 0 : _u.fontSize,
                    offsetCenter: (_w = (_v = defaults.detail) === null || _v === void 0 ? void 0 : _v.offsetCenter) !== null && _w !== void 0 ? _w : [0, "65%"],
                },
                data: [
                    {
                        value: seriesItem.value,
                        name: seriesItem.name,
                    },
                ],
            };
        });
        var option = {
            legend: legend,
            tooltip: tooltip,
            series: series,
        };
        return option;
    },
    getDefaultSettings: function () { return ({
        legend: { show: false },
        tooltip: { enable: true, trigger: "item" },
        style: "basic",
        min: 0,
        max: 100,
        startAngle: 225,
        endAngle: -45,
        splitNumber: 10,
        showPointer: true,
        showProgress: true,
    }); },
};
export default gaugeChartAdapter;
